import React, { useState } from "react";
import { SpeedDial, SpeedDialIcon, SpeedDialAction } from "@material-ui/lab";
import { Hidden } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  buttonsContainer: {
    flex: 1
  },
  addButton: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.common.white,
    "&:hover": {
      color: theme.palette.secondary.light
    }
  },
  deleteButton: {
    backgroundColor: theme.palette.custom.error,
    color: theme.palette.common.white,
    "&:hover": {
      color: theme.palette.custom.error
    }
  },
  description: {
    maxWidth: "66%"
  },
  editButton: {
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.common.white,
    "&:hover": {
      color: theme.palette.grey[600]
    }
  },
  logo: {
    maxWidth: "100%"
  },
  row: {
    cursor: "pointer"
  },
  speedDial: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  }
}));

const SpeedDialButton = ({ buttons, hidden, toggleForm }) => {
  const classes = useStyles();
  const [state, setState] = useState({
    speeddial: false
  });

  const { speeddial } = state;

  const toggleSpeedDial = () => {
    setState(prevState => ({ ...prevState, speeddial: !speeddial }));
    if (!buttons) {
      toggleForm("showForm");
      toggleForm("showFormCommunity");
      toggleForm("showFormParking");
    }
  };

  return (
    <Hidden mdUp>
      <SpeedDial
        classes={{ root: classes.speedDial }}
        ariaLabel="SpeedDial"
        icon={<SpeedDialIcon />}
        onClick={toggleSpeedDial}
        open={speeddial}
        hidden={hidden}
      >
        {buttons
          ? buttons.map(button => {
              return (
                <SpeedDialAction
                  key={button.id}
                  icon={button.icon}
                  tooltipTitle={button.title}
                  tooltipOpen
                  onClick={event => {
                    setState(prevState => ({
                      ...prevState,
                      speeddial: !speeddial
                    }));
                    toggleForm("showForm");
                    button.action();
                  }}
                  className={classes.editButton}
                />
              );
            })
          : null}
      </SpeedDial>
    </Hidden>
  );
};

export default SpeedDialButton;
